import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContractSelectorStateService } from 'src/app/shared/contract-selector-state-service/contract-selector-state.service';


@Component({
  selector: 'app-cedant-view',
  templateUrl: './cedant-view.component.html',
  styleUrls: ['./cedant-view.component.scss']
})
export class CedantViewComponent implements OnInit {

  constructor(private route:                 ActivatedRoute,
              private contractSelectorState: ContractSelectorStateService) { }

  cedantId = 0;

  ngOnInit() {
    this.route.paramMap.subscribe( paramMap => {
      this.cedantId = Number.parseInt(paramMap.get('id'), 10);
      this.contractSelectorState.setCurrentCedanById(this.cedantId);
      this.contractSelectorState.setCedantActive();
    });
  }

}
